module.exports = __webpack_public_path__ + "zmenseni-prsou_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_4_before.jpg
// module id = 1284
// module chunks = 0